<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./now" routerLinkActive="active" class="nav-link" href="#">Now</a>
  </li>
  <li class="nav-item">
    <a routerLink="./upcoming" routerLinkActive="active" class="nav-link" href="#">Upcoming</a>
  </li>
  <li class="nav-item">
    <a routerLink="./past" routerLinkActive="active" class="nav-link" href="#">Past</a>
  </li>
  <li class="nav-item">
    <a routerLink="./calendar" routerLinkActive="active" class="nav-link" href="#">Calendar</a>
  </li>
  <li class="nav-item">
    <a routerLink="./waitlists" routerLinkActive="active" class="nav-link" href="#">Waitlists</a>
  </li>
  <li class="nav-item">
    <a routerLink="./rosters" routerLinkActive="active" class="nav-link" href="#">Rosters</a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
